package com.essntl.config

import kotlin.OptIn
import kotlin.String
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
@OptIn(ExperimentalJsExport::class)
public object EssntlConfig {
  public val buildType: String = "debug"

  public val buildFlavor: String = "RELEASE"

  public val essntlBaseUrl: String = "https://odia.club"

  public val supabaseKey: String =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxtcGZsa2xkZG9mbWNicXNmZG90Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTYzMzk4MzMsImV4cCI6MjAxMTkxNTgzM30.r_QmcE2G653d94rb7DpU3wPhiUStJVwxtqOePenLrvk"

  public val supabaseUrl: String = "https://lmpflklddofmcbqsfdot.supabase.co"

  public val supabaseStorageUrl: String = "storage/v1/object/public"

  public val unsplashAccessKey: String = "8oZkGWiHlS8WdS-bz4v9nZcN4zPnMeTrGjptSQ6cOQg"

  public val waypointUsername: String = "658e8334017a4076b8a44bdc"

  public val waypointPassword: String = "twG1xF3KdBngEWEtihcZwiv3"

  public val twilioAccountId: String = "AC81126c2b4216726e44f7842daf57f0ea"

  public val twilioPassword: String = "58abe0771bcedd0806d89f21eae960dd"

  public val axusUsername: String = "beessentialclub@gmail.comr"

  public val axusPassword: String = "roxjuc-4wepbo-bymhYd"

  public val axusClientId: String = "2c3f9d77-c940Dash-4e25-a613-41a71775ba28"

  public val openAIKey: String = "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"

  public val stripeKey: String =
      "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"

  public val sentryDns: String =
      "https://4758d6f7e76d96b757b29a21d5d05cae@o4506663911948288.ingest.sentry.io/4506663929380864"

  public val version: String = "1.2.6.12"

  public val whatsappPhoneNumberId: String = ""

  public val whatsappAuthToken: String =
      "EAALkQFxF9ncBOZB5FlnUsks7urOwzvwy0IwzNFmgZAKcJDu4z4msScvgWFhUrW0MTBV2dnOdA57ULBcQZBGFGjdgYZBIiQVaD9oFqIBrA1r938VlQqCIWKnp197T4DHV4uRVVmkujapLMKgh3AxbahKimBPiFa59Qqd5InA17C2wQeZCR2MR1YZB8uNO5Mz6IKmKUKPY6dhHihVNze"

  public val quickbooksBaseUrl: String =
      "https://quickbooks.api.intuit.com/v3/company/9130350302252926"

  public val quickbooksRefreshTokenUrl: String = "https://essntl-qb-auth.onrender.com"

  public val quickbooksIncomeAccountId: String = "26"

  public val whapiAuthToken: String = "qtTSZVIheQNauyiVONhJ2Z4v2yWXWZze"

  public val backofficeUrl: String = "https://backoffice.odia.app"
}
